import title from "./title";

export default{
    ...title
}